export default "__VITE_ASSET__GywXxEw8__"